<template>
  <v-dialog :value="dialog" max-width="500" persistent>
    <v-card>
      <v-form v-on:submit.prevent="confirm">
        <v-card-title>
          <span class="headline">Anular recibos</span>
        </v-card-title>

        <v-card-text>
          <p class="mb-5">
            Se anulan <b>{{ voidable.length }}</b> recibos con el mismo motivo. Quedan en el historial, no se borran. Para
            cargar un reemplazo, anule el recibo desde su fila.
          </p>

          <v-textarea v-model="reason" label="Motivo*" name="reason" data-vv-as="motivo" v-validate="'required|max:1000'"
            rows="3"></v-textarea>
          <span class="red--text">{{ errors.first("reason") }}</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading" :disabled="voidable.length == 0">Anular</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { PAYSLIP_STATUS_VOIDED } from "@/constants/payslips";

// Anulacion de varios recibos seleccionados (sin reemplazo)
export default {
  props: {
    dialog: Boolean,
    payslips: { type: Array, default: () => [] },
  },
  data() {
    return {
      reason: "",
      loading: false,
    };
  },
  computed: {
    voidable() {
      return this.payslips.filter((payslip) => payslip.status != PAYSLIP_STATUS_VOIDED);
    },
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.reason = "";
      this.$validator.reset();
    },
  },
  methods: {
    close() {
      this.$emit("updateDialog", false);
    },
    async confirm() {
      if (this.loading || !(await this.$validator.validate())) return;

      this.loading = true;
      payslipService
        .void_many({ ids: this.voidable.map((payslip) => payslip.id), reason: this.reason })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("saved");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al anular los recibos.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
